var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"sentinela",staticClass:"sentinela-rolagem",attrs:{"aria-hidden":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }